'use client';

import { isString } from 'lodash';
import { useParams } from 'next/navigation';

export const useURLLibraryId = (): string | undefined => {
  const params = useParams();

  if (!params) {
    return undefined;
  }
  const value = params.libraryId;

  return isString(value) ? value : undefined;
};
